module.exports = __webpack_public_path__ + "static/media/中高鉄道研究部.eec9a696.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/中高鉄道研究部.png
// module id = 314
// module chunks = 10